



































































































































































import Vue from 'vue'
import { Component, Prop, Emit } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'

import AppDialog from '@/components/AppDialog.vue'
import FoldingCard from '@/components/FoldingCard.vue'
import { Account } from '@/modules/Account/interfaces/account'
import CertificateOfInsuranceDialog from '@/modules/CertificateOfInsurance/scripts/certificate-dialog'
import { AccountAssetType, AssetProperty, AssetVehicle } from '../interfaces/account-asset'
import { getAccountAssets } from '../gql/account.gql'
import { showErrors } from '@/utils/snack'
import dollarFilter from '@/utils/dollarFilter'
import { dateToDisplay } from '@/utils/dateTime'
import AssetVehicleDialog from '@/modules/AccountAsset/scripts/asset-vehicle-dialog'
import AssetPropertyDialog from '@/modules/AccountAsset/scripts/asset-property-dialog'
import { showOwnershipLabel } from '@/modules/Vehicle/helpers/vehicle-ownership-options'
import { showUseageLabel } from '@/modules/Vehicle/helpers/vehicle-useage-options'
@Component({
  components: {
    FoldingCard,
    AppDialog
  }
})
export default class AccountDetailAsset extends mixins(AssetVehicleDialog, AssetPropertyDialog) {
  @Prop({ type: Object as () => Account }) readonly account!: Account
  showOwnershipLabel = showOwnershipLabel
  showUseageLabel = showUseageLabel
  accountId: number | null = null

  loading = false

  properties: AssetProperty[] = []
  vehicles: AssetVehicle[] = []

  propertyTableColumn = [
    { field: 'name',
      title: 'Name',
      slots: { default: 'name' },
      width: 200,
      resizable: true
    },
    { field: 'address',
      title: 'Address',
      slots: { default: 'address' },
      resizable: true
    },
    { field: 'city',
      title: 'City',
      slots: { default: 'city' },
      width: 100,
      resizable: true
    },
    { field: 'state',
      title: 'State',
      slots: { default: 'state' },
      width: 100,
      resizable: true
    },
    { field: 'zipCode',
      title: 'Zip Code',
      slots: { default: 'zipCode' },
      width: 100,
      resizable: true
    },
    { field: 'country',
      title: 'Country',
      slots: { default: 'country' },
      width: 100,
      resizable: true
    },
    { field: 'owner',
      title: 'Owner',
      slots: { default: 'owner' },
      width: 150,
      resizable: true
    },
    { field: 'price',
      title: 'Price',
      slots: { default: 'price' },
      width: 120,
      resizable: true
    },
    { field: 'creationTime',
      title: 'Creation Time',
      slots: { default: 'creationTime' },
      width: 130,
      resizable: true
    },
    { field: 'buyTime',
      title: 'Buy Time',
      slots: { default: 'buyTime' },
      width: 130,
      resizable: true
    },
    { field: 'actions', title: 'Actions', slots: { default: 'action_default' }, fixed: 'right', width: 90 }
  ]

  vehicleTableColumn = [
    { field: 'name',
      title: 'Name',
      slots: { default: 'name' },
      width: 200,
      resizable: true
    },
    { field: 'vid',
      title: 'VIN',
      slots: { default: 'vid' },
      width: 100,
      resizable: true
    },
    { field: 'brand',
      title: 'Brand',
      slots: { default: 'brand' },
      width: 200,
      resizable: true
    },
    { field: 'color',
      title: 'Color',
      slots: { default: 'color' },
      width: 100,
      resizable: true
    },
    { field: 'type',
      title: 'Vehicle Type',
      slots: { default: 'type' },
      minWidth: 150,
      resizable: true
    },
    { field: 'ownership',
      title: 'Ownership',
      slots: { default: 'ownership' },
      minWidth: 150,
      resizable: true
    },
    { field: 'useage',
      title: 'Useage',
      slots: { default: 'useage' },
      minWidth: 150,
      resizable: true
    },
    { field: 'price',
      title: 'Price',
      slots: { default: 'price' },
      width: 220,
      resizable: true
    },
    { field: 'owner',
      title: 'Owner',
      slots: { default: 'owner' },
      width: 220,
      resizable: true
    },
    { field: 'actions', title: 'Actions', slots: { default: 'action_default' }, fixed: 'right', width: 90 }
  ]

  dollarFilter = dollarFilter
  dateToDisplay = dateToDisplay

  mounted () {
    this.getAssets()
  }

  // 获取claim list
  async getAssets () {
    this.loading = true
    try {
      const result = await this.$apollo.query({
        query: getAccountAssets,
        variables: {
          accountId: +this.account.id,
          filter: {}
        }
      })
      const assets = result.data.getAccountAssets.accountAssets
      this.properties = []
      this.vehicles = []
      for (const asset of assets) {
        if (asset.type === AccountAssetType.PROPERTY) {
          this.properties.push(asset)
        } else {
          this.vehicles.push(asset)
        }
      }
      this.loading = false
    } catch (e) {
      showErrors(e.graphQLErrors)
    }
  }

  routeTo (name: string, params: any) {
    this.$router.push({
      name,
      params
    })
  }

  routeToDetail (item: any) {
    return {
      name: 'CertificateOfInsuranceDetailDetail',
      params: {
        id: item.id,
        accountId: this.account.id,
        accountName: this.account.name
      }
    }
  }

  routeToPolicy (item: any) {
    return {
      name: 'PolicyDetailDetail',
      params: {
        id: item.id
      }
    }
  }

  newProperty (e: Event) {
    e.preventDefault()
    e.stopPropagation()
    this.accountId = Number(this.account.id)
    this.showPropertyEditDialog(e)
  }

  newVehicle (e: Event) {
    e.preventDefault()
    e.stopPropagation()
    this.accountId = Number(this.account.id)
    this.showVehicleEditDialog(e)
  }

  async deletePropertyConfirm () {
    if (!this.targetAccountAsset) {
      return
    }
    await this.deletePropertyPost()
    this.getAssets()
  }

  async deleteVehicleConfirm () {
    if (!this.targetAccountAsset) {
      return
    }
    await this.deletePropertyPost()
    this.getAssets()
  }

  @Emit('refresh')
  onFormSuccess () {
    // do nothing
  }
}
